import Link from 'next/link';
import type { ComponentProps } from 'react';

import styles from './sign-up-link.component.module.scss';

type Props = Omit<ComponentProps<typeof Link>, 'href'>;

export const SignUpLink = ({ className, ...rest }: Props) => {
  return (
    <Link
      className={[styles.signUpLink, className].filter(Boolean).join(' ')}
      href="/users/sign_up"
      {...rest}
    >
      新規登録
    </Link>
  );
};
